import { render, staticRenderFns } from "./AddImageBanner.vue?vue&type=template&id=054b4359"
import script from "./AddImageBanner.vue?vue&type=script&lang=js"
export * from "./AddImageBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports